module.exports = __webpack_public_path__ + "img/tyree.074abce7.png";